export enum ModelArtifactArchivedStatus {
  Active = "Active",
  Archived = "Archived",
}

export function isArchivedStatus(archiveStatus: string | ModelArtifactArchivedStatus | undefined): boolean {
  if (archiveStatus == null) return false;
  return String(archiveStatus).toLowerCase() === ModelArtifactArchivedStatus.Archived.toLowerCase();
}
